import react from "react";

import aaa1 from "../images/commercials/AAA/TESTWITHULRIKE_001 Large.jpeg";
import aaa2 from "../images/commercials/AAA/TESTWITHULRIKE_002 Large.jpeg";
import aaa3 from "../images/commercials/AAA/TESTWITHULRIKE_003 Large.jpeg";
import aaa4 from "../images/commercials/AAA/TESTWITHULRIKE_004 Large.jpeg";
import aaa5 from "../images/commercials/AAA/TESTWITHULRIKE_005 Large.jpeg";
import aaa6 from "../images/commercials/AAA/TESTWITHULRIKE_006 Large.jpeg";

const Milk = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={aaa1} alt="Milk - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={aaa2} alt="Milk - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={aaa3} alt="Milk - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={aaa4} alt="Milk - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={aaa5} alt="Milk - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={aaa6} alt="Milk - Image 6"/>
                </div>
            </div>
        </div>
    );
}

export default Milk;